<template>
<div class="route"
     :class="{ 'in-transition': inTransition }"
     :style="{ 'max-width': webWidth + 'px', transform: iphoneX ? `translateY(${translateY - 34}px)`: `translateY(${translateY}px)`, bottom: list[activeIndex].meta.vehicle === 'foot' || list[activeIndex].meta.vehicle === 'car' ? 'calc(-100vh + ' + offset +'px + 59px + 116px)' : 'calc(-100vh - ' + offset + 'px  + 59px + 110px)' }"
     @touchstart="handleTouchStart"
     @touchmove="handleTouchMove"
     @touchend="handleTouchEnd"
     @touchcancel="handleTouchEnd"
     @transitionend="handleTransitionEnd"
     @transitioncancel="handleTransitionEnd">
  <div class="move-trigger" ref="trigger">
    <div class="arrow-down" v-if="expand">
      <img src="../../assets/slide-down.svg" />
    </div>
    <div class="line" v-else></div>
    <div class="route-brief" ref="brief">
      <div class="route-top">
        <div class="route-time">{{ formatTime(list[activeIndex].paths[0].time) }} | {{ formatDistance(list[activeIndex].paths[0].distance) }}</div>
        <div class="route-label" v-if="list[activeIndex].meta.weighting === 'fastest'">{{ $t('navigate.tagFastest') }}</div>
        <div class="route-label purple" v-else-if="list[activeIndex].meta.weighting === 'foot_most_sheltered'">{{ $t('navigate.tagMostSheltered') }}</div>
      </div>
      <div class="type-wrapper" v-if="list[activeIndex].meta.vehicle !== 'foot' && list[activeIndex].meta.vehicle !== 'car'">
        <div class="type"
            v-for="(point, index) in list[activeIndex].routeArray"
            :key="`route-${index}`">
          <div class="walk" v-if="point.type === 0">
            <img src="../../assets/navigate/walk.svg"  />
            <!-- <div class="type-name walk">步行</div> -->
            <!-- <div class="time">5min</div> -->
          </div>
          <div class="bus" v-else-if="point.type === 1">
            <img src="../../assets/navigate/bus-sentosa.svg" v-if="siteId === '1'" />
            <img src="../../assets/navigate/bus.svg" v-else />
            <div class="type-name bus">{{ $t('navigate.bus') }}A</div>
          </div>
          <div class="bus" v-else-if="point.type === 2">
            <img src="../../assets/navigate/bus-sentosa.svg" v-if="siteId === '1'" />
            <img src="../../assets/navigate/bus.svg" v-else />
            <div class="type-name bus">{{ $t('navigate.bus') }}B</div>
          </div>
          <div class="bus" v-else-if="point.type === 3">
            <img src="../../assets/navigate/bus-sentosa.svg" v-if="siteId === '1'" />
            <img src="../../assets/navigate/bus.svg" v-else />
            <div class="type-name bus">{{ $t('navigate.bus') }}123</div>
          </div>
          <div class="cable" v-else-if="point.type === 4">
            <img src="../../assets/navigate/express.svg" />
            <div class="type-name express">{{ $t('navigate.express') }}</div>
          </div>
          <div class="cable" v-else-if="point.type === 5">
            <img src="../../assets/navigate/tram.svg" />
            <div class="type-name tram">{{ $t('navigate.tram') }}</div>
          </div>
          <div class="cable" v-else-if="point.type === 6">
            <img src="../../assets/navigate/cable-sentosa.svg" v-if="siteId === '1'" />
            <img src="../../assets/navigate/cable.svg" v-else />
            <div class="type-name cable">{{ $t('navigate.cable') }}</div>
          </div>
          <div class="arrow" v-if="index < list[activeIndex].routeArray.length - 1">
            <img src="../../assets/navigate/arrow-right.svg" />
          </div>
        </div>
      </div>
      <div class="arrive-time">{{ $t('navigate.arriveTime') }}: {{ list[activeIndex].paths[0].time | formatArrival }}</div>
    </div>
  </div>
  <!-- 步行驾车路线详情 -->
  <WalkDetail ref="walkDetail" :iphoneX="iphoneX" :offset="offset" :expand="expand" v-if="list[activeIndex].meta.vehicle === 'foot' || list[activeIndex].meta.vehicle === 'car'" :route="list[activeIndex]" :startName="startName" :endName="endName" />
  <!-- 巴士路线详情 -->
  <BusDetail ref="walkDetail" :iphoneX="iphoneX" :offset="offset" :expand="expand" v-else :route="list[activeIndex]" :startName="startName" :endName="endName" />
</div>
</template>

<script>
import WalkDetail from './WalkDetail'
import BusDetail from './BusDetail'
import { clamp as _clamp } from 'lodash'
import moment from 'moment'

export default {
  data () {
    return {
      hold: false,
      startY: 0,
      lastTouch: {
        y: 0,
        t: 0
      },
      speed: 0,
      translateY: 0,
      inTransition: false,
      expand: false
    }
  },
  computed: {
    siteId () {
      return this.$store.state.siteId
    },
    webWidth () {
      return this.$store.state.webWidth
    }
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    activeIndex: {
      type: Number,
      default: null
    },
    endName: {
      type: String,
      default: ''
    },
    startName: {
      type: String,
      default: ''
    },
    iphoneX: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Number,
      default: 0
    }
  },
  components: {
    WalkDetail,
    BusDetail
  },
  methods: {
    formatDistance (val) {
      let s = ''
      if (val < 1000) {
        s = Math.round(val) + ' ' + this.$t('common.metre')
      } else {
        s = Math.round(parseInt(val * 10) / 1000) / 10 + ' ' + this.$t('common.kilometre')
      }
      return s
    },
    formatTime (val) {
      if (!val) {
        return ''
      } else {
        const duration = moment.duration(val, 'ms')
        const hours = duration.hours()
        const minutes = duration.minutes()
        console.log(duration, hours, minutes)
        let str = ''
        if (hours > 0) {
          str += hours + this.$t('common.hour')
        }
        if (minutes > 0 && hours === 0) {
          str += minutes + this.$t('common.minute')
        } else if (minutes > 0) {
          str += minutes + this.$t('common.min')
        }
        return str
      }
    },
    // 开始滑动
    handleTouchStart (e) {
      if (this.$refs.walkDetail.scrollTop < 0 && !this.$refs.trigger.contains(e.target)) return
      if (!this.expand) {
        e.preventDefault()
      }
      if (this.inTransition) { return }

      this.hold = true
      this.startY = e.touches[0].clientY
      this.lastTouch = {
        y: e.touches[0].clientY,
        t: Date.now()
      }
    },
    // 滑动中
    handleTouchMove (e) {
      if (this.inTransition) { return }
      if (!this.hold) { return }

      const offsetY = e.touches[0].clientY - this.lastTouch.y
      const now = Date.now()
      const speed = offsetY / (now - this.lastTouch.t) * 1000
      const slideHeight = this.$refs.brief.clientHeight
      const windowHeight = this.iphoneX ? window.innerHeight - (134 + this.offset) : window.innerHeight - (100 + this.offset)
      this.translateY = _clamp(this.translateY + offsetY, slideHeight - windowHeight, 0)
      this.speed = speed
      this.lastTouch = {
        y: e.touches[0].clientY,
        t: now
      }
    },
    // 滑动结束
    handleTouchEnd () {
      if (this.inTransition) { return }
      if (!this.hold) { return }
      const slideHeight = this.$refs.brief.clientHeight
      const windowHeight = this.iphoneX ? window.innerHeight - (134 + this.offset) : window.innerHeight - (100 + this.offset)

      this.hold = false
      console.log('translateY', this.translateY)
      if (this.translateY === 0) {
        this.expand = false
        this.$emit('mask', false)
        return
      } else if (this.translateY === slideHeight - windowHeight) {
        this.expand = true
        this.$emit('mask', true)
        return
      }
      this.inTransition = true
      // if (this.speed < -40 || (this.translateY < (slideHeight - windowHeight) / 2) && this.speed >= -40 && this.speed < 40) {
      //   this.expand = true
      // } else {
      //   this.expand = false
      // }
      // if (this.speed > 0 && this.translateY <= 100 + slideHeight - windowHeight) {
      //   this.expand = true
      //   this.$emit('mask', true)
      // } else if (this.speed < 0 && this.translateY < -100) {
      //   this.expand = true
      //   this.$emit('mask', true)
      // } else {
      //   this.expand = false
      //   this.$emit('mask', false)
      // }
      if (this.speed > 0 && this.translateY > slideHeight - windowHeight) {
        this.expand = false
        this.$emit('mask', false)
      } else if (this.speed < 0 && this.translateY >= -100) {
        this.expand = false
        this.$emit('mask', false)
      } else {
        this.expand = true
        this.$emit('mask', true)
      }

      this.$nextTick(() => {
        const currentHeight = this.$refs.brief.clientHeight // 样式有变，重新计算高度
        // if (this.speed > 40) {
        //   this.translateY = 0
        // } else if (this.speed < -40) {
        //   this.translateY =  currentHeight - windowHeight
        // } else {
        //   if (this.translateY < (slideHeight - windowHeight) / 2) {
        //     this.translateY =  currentHeight - windowHeight
        //   } else {
        //     this.translateY = 0
        //   }
        // }
        console.log('speed', this.speed)
        if (this.speed > 0) { // 下滑
          if (this.translateY > currentHeight - windowHeight) {
            this.translateY = 0
          } else {
            this.translateY = currentHeight - windowHeight
          }
        } else {
          if (this.translateY < -100) {
            this.translateY = currentHeight - windowHeight
          } else {
            this.translateY = 0
          }
        }
      })
    },
    // 展开详情
    handleExpand () {
      this.expand = true
      this.inTransition = true
      this.$emit('mask', true)
      this.$nextTick(() => {
        const currentHeight = this.$refs.brief.clientHeight // 样式有变，重新计算高度
        const windowHeight = this.iphoneX ? window.innerHeight - (134 + this.offset) : window.innerHeight - (100 + this.offset)
        this.translateY = currentHeight - windowHeight
      })
    },
    // 关闭详情
    handleClose () {
      this.expand = false
      this.inTransition = true
      this.$emit('mask', false)
      this.$nextTick(() => {
        this.translateY = 0
      })
    },
    handleTransitionEnd () {
      this.inTransition = false
    },
    handleStop () {}
  }
}
</script>

<style lang="scss" scoped>
.route {
  max-width: 375px;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 12;
  height: calc(100vh - 59px + 0.45rem);
  background-color: #ffffff;
  bottom: calc(-100vh + 59px + 110px);
  border-radius: 8px 8px 0 0;

  .move-trigger {
    padding-top: 13px;
  }

  .line {
    width: 24px;
    height: 2px;
    background-color: #dddddd;
    margin: 0 auto ;
  }
  &.in-transition {
    transition: all .3s ease;
  }

  &-brief {
    padding: 12px 12px 10px;
    border-bottom: 4px solid #f7f7f7;
  }

  &-top {
    display: flex;
    align-items: center;
  }

  &-time {
    font-size: 14px;
    line-height: 20px;
    color: #222215;
    font-weight: bold;
    font-family: GothamBold;
  }

  &-label {
    background-color: #ffe692;
    height: 18px;
    // width: 58px;
    padding: 0 9px;
    line-height: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-size: 10px;
    color: #f8a909;
    margin-left: 8px;

    &.purple {
      background-color: #a5b2dc;
      color: #5c5ca5;
    }
  }

  .arrive-time {
    font-size: 12px;
    line-height: 17px;
    color: #888888;
    margin-top: 8px;
  }

  .route-btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0 5px;
    border-top: 1px solid #efefef;
    margin-top: 11px;
    &.bottom {
      padding: 8px 12px 14px;
    }
  }

  .show-map {
    display: flex;
    align-items: center;

    span {
      font-size: 16px;
      color: #222215;
      margin-left: 9px;

      &.small {
        font-size: 14px;
      }
    }
  }

  .arrow-down img {
    width: 29px;
    height: 8px;
    margin: 0 auto;
    display: block;
  }

  // .start-nav {
  //   background-color: #f8a909;
  //   width: 106px;
  //   height: 40px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   border-radius: 20px;
  //   font-size: 16px;
  //   color: #ffffff;
  // }

  .type-wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .type {
      display: flex;
      align-items: center;
      margin-top: 9px;
    }

    .arrow {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 4px;
    }

    img {
      margin-right: 3px;
    }

    .walk {
      display: flex;
      align-items: center;
      color: #00aeef;
      font-size: 10px;

      .time {
        line-height: 14px;
      }
    }

    .bus {
      display: flex;
      align-items: center;
    }

    .type-name {
      font-size: 12px;
      padding: 0 5px;
      line-height: 16px;
      border-radius: 4px;
      color: #ffffff;

      &.walk {
        background-color: #00aeef;
      }

      &.bus {
        background-color:#f8a909;
      }

      &.cable {
        background-color: #5c2d91;
      }

      &.tram {
        background-color: #f15b67;
      }

      &.express {
        background-color: #28752b;
      }
    }

    .cable {
      display: flex;
      align-items: center;
    }
  }
}
</style>
